import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function ChevronUp(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M2.28567 15.6614C2.11178 15.8296 2 16.0609 2 16.3269C2 16.86 2.4099 17.2746 2.94764 17.2746C3.20437 17.2746 3.44966 17.1768 3.60856 17.0029L12.5721 7.70594H11.4279L20.3868 17.0029C20.5504 17.1768 20.8117 17.2746 21.0627 17.2746C21.5958 17.2746 22 16.86 22 16.3269C22 16.0609 21.8929 15.8342 21.719 15.666L12.716 6.31929C12.5281 6.11074 12.2725 6 12.0029 6C11.7229 6 11.4776 6.10607 11.2944 6.31465L2.28567 15.6614Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
